import { Color } from "@constants/V2/color"
import { EcoSystemFields } from "@hooks/V2/storyblok"
import { getComponentColorTheme } from "@utils/V2/color"

/**
 * Returns the correct payment strip object based on background color and available strips.
 * @param ecoSystemFields The ecosystem fields object containing paymentStripLight and paymentStripDark
 * @param backgroundColor The background color to determine theme (optional)
 */
export function getPaymentStrip(
  ecoSystemFields: EcoSystemFields,
  backgroundColor?: string
): { filename?: string } | undefined {
  if (ecoSystemFields.paymentStripLight && ecoSystemFields.paymentStripDark) {
    return getComponentColorTheme(
      (backgroundColor as Color) ?? Color.Charcoal
    ) === "dark"
      ? ecoSystemFields.paymentStripLight
      : ecoSystemFields.paymentStripDark
  }
  return undefined
}
